import { Injectable } from '@angular/core'
import { environment } from '../../../../../environments/environment'
import { HttpClient, HttpHeaders } from '@angular/common/http'
import { Observable } from 'rxjs'

@Injectable({
  providedIn: 'root',
})
export class GoogleMapsLoaderService {
  private url = 'https://places.googleapis.com/v1/places'

  constructor(private httpClient: HttpClient) {}

  autocomplete(model: any): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'X-Goog-Api-Key': environment.googleMapsApiKey,
      'X-Goog-FieldMask': '*',
    })
    return this.httpClient.post(`${this.url}:autocomplete`, model, { headers })
  }

  getPlaceDetails(placeId: string): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'X-Goog-Api-Key': environment.googleMapsApiKey,
      'X-Goog-FieldMask': '*',
    })
    return this.httpClient.get(`${this.url}/${placeId}`, { headers })
  }
}
